import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const Check = styled.div`
    display: flex;

    margin-bottom: 2px;

    width: ${({ percentWidth }) => `${percentWidth}%`};
`;

export const InputContainer = styled.div`
    font-size: ${theme.font.size5};

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    padding: 0 5px;
`;

export const Square = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 8px;
    height: 8px;
    background: #cccccc9e;

    border: 1px solid #CCC;

    margin-right: 5px;

    ${({ checked }) => {
        if (checked) {
            return `
                &:after {
                    margin-top: -3px;
                    content: "X";
                }
            `;
        }

        return ``;
    }}
`;

export const Label = styled.div``;
